export default "/template/resource//static/media/img_bg_login@2x.bef6b397.png";